import * as BaseActivityTemplate from './components/BaseActivityTemplate';
import * as SuperAdminActivityTemplate from './components/SuperAdminActivityTemplate/SuperAdminActivityTemplate';
export * as AuthWrapper from './AuthWrapper/AuthWrapper';

export * as fields from './fields';
export * as BaseOnboardingTemplate from './components/BaseOnboardingTemplate';

export * as UserTypeSelectionCard from './components/UserTypeSelectionCard/UserTypeSelectionCard';
export * as enumCache from './enumCache';

export {
  FileInputField,
  fileData2EncodedString
} from './FileInputField/FileInputField';

export type { IFileData } from './FileInputField/FileInputField';

export const activityTemplates = {
  BaseActivityTemplate,
  SuperAdminActivityTemplate
};
